import type { AdminReviewListItemResponse } from "../../../types/adminTypes";
import { formatDateTime } from "../../../utils/DateUtils";
import Button from "../../ui/Button/Button";
import AdminPillBadge from "../ui/AdminPillBadge";
import {
  getFullName,
  getReviewContextLabel,
  getReviewContextTone,
  getStatusTone,
} from "./adminReviewUtils";

type AdminReviewsTableRowProps = {
  review: AdminReviewListItemResponse;
  onView: (review: AdminReviewListItemResponse) => void;
};

const AdminReviewsTableRow = ({ review, onView }: AdminReviewsTableRowProps) => {
  const reviewerName = getFullName(review.reviewerFirstName, review.reviewerLastName, "Unknown reviewer");
  const revieweeName = getFullName(review.revieweeFirstName, review.revieweeLastName, "Unknown reviewee");
  const teenName = getFullName(review.teenFirstName, review.teenLastName, "Unknown teen");
  const posterName = getFullName(review.posterFirstName, review.posterLastName, "Unknown poster");

  return (
    <tr className="align-top">
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">
        <div className="space-y-2">
          <AdminPillBadge>{review.rating.toFixed(1)} / 5</AdminPillBadge>
          <p className="line-clamp-2 text-myteengig-text-muted">
            {review.message?.trim() || "No written feedback was included."}
          </p>
        </div>
      </td>
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">
        <div className="space-y-2">
          <p className="font-semibold">{review.gigTitle ?? "Untitled gig"}</p>
          <div className="flex flex-wrap gap-2">
            {review.gigStatus ? <AdminPillBadge tone={getStatusTone(review.gigStatus)}>{review.gigStatus}</AdminPillBadge> : null}
            {review.gigRequestStatus ? <AdminPillBadge tone={getStatusTone(review.gigRequestStatus)}>{review.gigRequestStatus}</AdminPillBadge> : null}
          </div>
        </div>
      </td>
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">
        <div className="space-y-1">
          <p>Reviewer: {reviewerName}</p>
          <p className="text-myteengig-text-muted">Reviewee: {revieweeName}</p>
          <p className="text-myteengig-text-muted">Teen: {teenName}</p>
          <p className="text-myteengig-text-muted">Poster: {posterName}</p>
        </div>
      </td>
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">
        <AdminPillBadge tone={getReviewContextTone(review.reviewContext)}>
          {getReviewContextLabel(review.reviewContext)}
        </AdminPillBadge>
      </td>
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">{formatDateTime(review.createdAt)}</td>
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">
        <Button variant="outline" size="sm" onClick={() => onView(review)}>
          View
        </Button>
      </td>
    </tr>
  );
};

export default AdminReviewsTableRow;
